import SummaryExpenses from "./SummaryExpenses";

export default SummaryExpenses;
